<template>
<svg data-svg-lvl-3="flyleaffront-block-flyleaffront" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430"><defs><mask id="lff-m-f" x="0" y="0" width="500" height="430" fill="#ffffff"><path  d="M259.8537,347.9799h176.7416c6.2787,0,11.3685-5.0899,11.3685-11.3685l.0002-244.0896c0-6.2787-5.0899-11.3685-11.3685-11.3685h-176.7418v266.8267Z"/></mask></defs><g id="Форзац"> <path  :style="{ fill: params.flyleaffrontColor }"  class="lff-c-2" d="M259.8537,347.9799h176.7416c6.2787,0,11.3685-5.0899,11.3685-11.3685l.0002-244.0896c0-6.2787-5.0899-11.3685-11.3685-11.3685h-176.7418v266.8267Z"/> <image v-if="params.flyleaffrontImage" preserveAspectRatio="xMidYMid slice" width="500" height="430" :href="params.flyleaffrontImage" mask="url(#lff-m-f)" /> </g></svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default {props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>

<style scoped>.lff-c-1{opacity:.3;}.lff-c-2{fill:#f4e8ce;}.lff-c-2,.lff-c-3{stroke-width:0px;}.lff-c-3{fill:#64ff00;}</style>

